<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-container fluid>
                <!-- 1st row : select name and type -->
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Type"
                            :items="typeOptions" 
                            :label="$t('lang_GENERIC_CAPTION_TYPE')" 
                            :alvqa="alvqa + '-dropdown-type'"
                            rules="required"
                            :clearable="false"
                            :withMargin="false"
                            :additionalFunction="autoFillIdByType"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageAutocomplete 
                            :context="context"
                            field="PersonObject"
                            :label="$t('lang_AZ_PERSONS_CAPTION_NAME')"
                            rules="required"
                            :withFreeText="false"
                            :withMargin="false"
                            :alvqa="alvqa + '-autocomplete-name'"
                            :additionalFunction="fillInName"
                            item-value="alvId"
                            v-if="getType !== 'recipientId'"
                        >
                            <template v-slot:selection="{ item }">
                                <div 
                                    class="ellipsis" 
                                    :alvqa="alvqa + '-autocomplete-name-selection'" 
                                >
                                    {{ $alvPlugin.getOtherIdsRoleLabel(item) }}
                                </div>
                            </template>
                            <template v-slot:items="{ items }">
                                <v-list-item-content :alvqa="alvqa + '-autocomplete-name-dropdown-' + items.alvId">
                                    <v-list-item-title :alvqa="alvqa + '-autocomplete-name-dropdown-' + items.alvId + '-title'">
                                        {{ $alvPlugin.getOtherIdsRoleLabel(items) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-name-dropdown-' + items.alvId + '-subtitle'">
                                        {{ items.alvId }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </BaseEditPageAutocomplete>
                        <BaseEditPageTextField 
                            field="Name"
                            :label="$t('lang_AZ_PERSONS_CAPTION_NAME')"
                            :context="context"
                            :clearable="false"
                            :withMargin="false"
                            :disabled="true"
                            :alvqa="alvqa + '-textfield-name'"
                            v-else
                        />
                    </v-col>
                </v-row>

                <!-- 2nd row : source and value -->
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="SourceAlvId"
                            :items="sourceOptions" 
                            :label="$t('lang_GENERIC_CAPTION_SOURCE')" 
                            :alvqa="alvqa + '-dropdown-source'"
                            :withMargin="false"
                            :rules="getType === 'recipientId' ? 'required' : ''"
                            :disabled="getType !== 'recipientId'"
                            :additionalFunction="fillInSource"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField
                            :context="context"
                            field="Value"
                            :label="$t('lang_GENERIC_CAPTION_ID')"
                            :alvqa="alvqa + '-textfield-id'"
                            :withMargin="false"
                            :rules="getType === 'recipientId' ? 'required' : ''"
                            :disabled="getType !== 'recipientId'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import { DropdownAzPersonsOtherIdsTypes } from '@/assets/dropdowns/alvDropdowns.js'


export default {
    name: "OtherIdsEditDialog",
    components: {
        EditingDialog,
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageAutocomplete,
    },
    data() {
        return {
            context: "AzGroupsOtherIds",
            alvqa: "az-groups-edit-form-other-ids-dialog",
            typeOptions: DropdownAzPersonsOtherIdsTypes,
        }
    },
    computed: {
        getType() {
            return this.$store.getters.getAzGroupsOtherIdsDetailsType
        },
        getAlvIdPerson() {
            return this.$store.getters.getAzGroupsOtherIdsDetailsAlvId
        },
        sourceOptions() {
            if (this.getType == 'recipientId') {
                return this.$store.getters.getAzForMappingsImport;
            }

            let list = [
                {
                    value: null,
                    text: "ALV",
                    alvqa: this.alvqa + '-dropdown-source-item-alv'
                }
            ]
            
            return list;
        },
    },
    methods: {
        fillInName (person) {
            if (person !== null && typeof person == 'object') {
                this.$store.commit('setAzGroupsOtherIdsDetailsName', person.gemaName)
                this.$store.commit('setAzGroupsOtherIdsDetailsAlvId', person.alvId)
                this.$store.commit('setAzGroupsOtherIdsDetailsSlgContractId', person.slgContractId || null)
                this.$store.commit('setAzGroupsOtherIdsDetailsSlgSubcatalogId', person.slgSubcatalogId || null)
                if (this.getType !== 'recipientId') {
                    this.$store.commit('setAzGroupsOtherIdsDetailsValue', person.alvId)
                }
            } else {
                this.$store.commit('setAzGroupsOtherIdsDetailsSlgContractId', null)
                this.$store.commit('setAzGroupsOtherIdsDetailsSlgSubcatalogId', null)
            }
        },
        fillInSource (source) {
            let sourceObj = this.sourceOptions.find((item) => item.value == source)
            this.$store.commit('setAzGroupsOtherIdsDetailsSource', sourceObj ? sourceObj.text : null)
        },
        autoFillIdByType (type) {
            this.$store.commit('setAzGroupsOtherIdsDetailsSourceAlvId', null)
            if (type !== 'recipientId') {
                this.$store.commit('setAzGroupsOtherIdsDetailsValue', this.getAlvIdPerson)
                this.$store.commit('setAzGroupsOtherIdsDetailsSource', null)
            } else {
                this.$store.commit('setAzGroupsOtherIdsDetailsValue', null)
                this.$store.commit('setAzGroupsOtherIdsDetailsName', '')
                this.$store.commit('setAzGroupsOtherIdsDetailsAlvId', null)
                this.$store.commit('setAzGroupsOtherIdsDetailsSlgContractId', null)
                this.$store.commit('setAzGroupsOtherIdsDetailsSlgSubcatalogId', null)
            }
        }
    },
    created() {
        this.$store.dispatch("fetchAzForMappings");
    },
}
</script>
